/*
 * RILDY — Régua de progresso do carrinho (frete grátis + brinde)
 *
 * O markup é renderizado pelo Liquid em snippets/rildy-cart-progress.liquid.
 * Este arquivo só recalcula mensagem, preenchimento e marcos quando o
 * carrinho muda, reaproveitando os eventos que o tema já dispara.
 */
(function () {
  'use strict';

  var CART_EVENTS = ['theme:cart:added', 'theme:cart:loaded', 'theme:cart:update', 'theme:cart:refresh'];

  /*
   * O total do carrinho é o único lugar em que o tema usa
   * moneyWithCurrencyFormat, e ele imprime "R$ 159,00 BRL". Como a loja
   * está com o código da moeda desligado nas configurações, apontamos
   * esse formato para o normal — o Liquid já faz o mesmo na primeira
   * renderização, isto cobre as atualizações via JS.
   */
  if (window.theme && window.theme.settings && !window.theme.settings.currency_code_enable) {
    window.theme.moneyWithCurrencyFormat = window.theme.moneyFormat;
  }

  function currencyRate() {
    if (window.Shopify && window.Shopify.currency && window.Shopify.currency.rate) {
      return parseFloat(window.Shopify.currency.rate) || 1;
    }
    return 1;
  }

  function formatMoney(cents) {
    var value = Math.max(0, Math.round(cents));

    if (window.theme && typeof window.theme.formatMoney === 'function') {
      var formatted = window.theme.formatMoney(value, window.theme.moneyFormat);

      // O tema esconde os centavos zerados nas mensagens de frete; seguimos igual.
      if (formatted.endsWith('.00') || formatted.endsWith(',00')) {
        formatted = formatted.slice(0, -3);
      }

      return formatted;
    }

    return (value / 100).toFixed(2);
  }

  class RildyCartProgress extends HTMLElement {
    connectedCallback() {
      this.messageEl = this.querySelector('[data-rildy-message]');
      this.fillEl = this.querySelector('[data-rildy-fill]');
      this.milestones = Array.from(this.querySelectorAll('[data-rildy-milestone]'));

      this.freeLimit = this.toCents(this.dataset.freeLimit);
      this.giftLimit = this.toCents(this.dataset.giftLimit);
      this.goal = Math.max(this.freeLimit, this.giftLimit);

      this.onCartChange = this.onCartChange.bind(this);
      CART_EVENTS.forEach((name) => document.addEventListener(name, this.onCartChange));

      // Estado inicial: o Liquid já renderizou o valor certo, mas o carrinho
      // pode ter mudado em outra aba antes do drawer abrir.
      this.refresh();
    }

    disconnectedCallback() {
      CART_EVENTS.forEach((name) => document.removeEventListener(name, this.onCartChange));
      clearTimeout(this.timer);
    }

    toCents(value) {
      var amount = parseFloat(value);
      if (!amount || amount <= 0) return 0;
      return amount * 100 * currencyRate();
    }

    onCartChange() {
      // Vários eventos chegam em sequência numa mesma atualização.
      clearTimeout(this.timer);
      this.timer = setTimeout(() => this.refresh(), 120);
    }

    refresh() {
      fetch(window.theme.routes.cart_url + '.js', {
        headers: { 'Content-Type': 'application/json' },
      })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart) this.render(cart.total_price);
        })
        .catch(() => {});
    }

    render(total) {
      if (!this.goal) return;

      var percent = Math.min(100, (total / this.goal) * 100);

      if (this.fillEl) {
        this.fillEl.style.setProperty('--rildy-progress', percent + '%');
      }

      this.milestones.forEach((milestone) => {
        var threshold = parseFloat(milestone.dataset.rildyMilestone) || 0;
        milestone.classList.toggle('is-reached', total >= threshold);
      });

      if (!this.messageEl) return;

      var message;

      if (this.freeLimit && total < this.freeLimit) {
        message = this.dataset.msgShipping;
      } else if (this.giftLimit && total < this.giftLimit) {
        message = this.dataset.msgGift;
      } else {
        message = this.dataset.msgComplete;
      }

      if (!message) {
        this.messageEl.innerHTML = '';
        return;
      }

      var remaining = total < this.freeLimit ? this.freeLimit - total : this.giftLimit - total;

      this.messageEl.innerHTML = message.replace(
        /\|\|amount\|\|/g,
        '<strong>' + formatMoney(remaining) + '</strong>'
      );
    }
  }

  if (!customElements.get('rildy-cart-progress')) {
    customElements.define('rildy-cart-progress', RildyCartProgress);
  }

  /*
   * Contador ao lado do "Carrinho" no cabeçalho.
   *
   * O Liquid já imprime o valor certo no carregamento; isto cobre as
   * mudanças feitas sem recarregar a página. O tema não expõe a
   * quantidade num atributo, só a classe cart__toggle--has-items, por
   * isso lemos o carrinho — a chamada é debounced junto com os vários
   * eventos que chegam numa mesma atualização.
   */
  var timerContador;

  function escreverContador(quantidade) {
    document.querySelectorAll('[data-rildy-cart-count]').forEach(function (el) {
      el.textContent = quantidade > 0 ? '(' + quantidade + ')' : '';
    });
  }

  /*
   * Carrinho vazio: a classe no drawer esconde a régua de frete/brinde e
   * a faixa "Leve também". O Liquid já marca no carregamento; aqui
   * acompanhamos as mudanças feitas sem recarregar.
   */
  function marcarVazio(quantidade) {
    var drawer = document.querySelector('.cart-drawer');
    if (drawer) drawer.classList.toggle('rildy-cart-vazio', quantidade === 0);
  }

  function atualizarContador() {
    clearTimeout(timerContador);
    timerContador = setTimeout(function () {
      fetch(window.theme.routes.cart_url + '.js', { headers: { 'Content-Type': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (cart) {
          if (!cart) return;
          escreverContador(cart.item_count);
          marcarVazio(cart.item_count);
        })
        .catch(function () {});
    }, 120);
  }

  CART_EVENTS.forEach(function (nome) { document.addEventListener(nome, atualizarContador); });

  /*
   * Faixa "Leve também".
   *
   * O tema monta um carrossel Flickity que centraliza UM card por vez e
   * não tem como mostrar dois sem reconfigurar a instância. Aqui ele é
   * desmontado e no lugar fica uma faixa de rolagem nativa com
   * scroll-snap: dois cards visíveis, arrastável no toque e com as
   * setas abaixo. Também devolvemos o tabindex que o Flickity tira dos
   * cards que não estavam selecionados.
   */
  function desmontarCarrossel(slider) {
    if (!slider || !slider.classList.contains('flickity-enabled')) return;

    var Flickity = window.theme && window.theme.Flickity;
    var flkty = Flickity && Flickity.data(slider);
    if (!flkty) return;

    flkty.destroy();

    slider.querySelectorAll('[tabindex="-1"]').forEach(function (el) {
      el.removeAttribute('tabindex');
    });
  }

  function atualizarSetas(slider) {
    var pair = slider.closest('.rildy-pair');
    if (!pair) return;

    var nav = pair.querySelector('.rildy-pair__nav');
    if (!nav) return;

    // Sem transbordo não há o que navegar
    var temMais = slider.scrollWidth - slider.clientWidth > 4;
    nav.classList.toggle('is-hidden', !temMais);

    var prev = pair.querySelector('[data-rildy-pair-prev]');
    var next = pair.querySelector('[data-rildy-pair-next]');
    if (prev) prev.disabled = slider.scrollLeft <= 2;
    if (next) next.disabled = slider.scrollLeft >= slider.scrollWidth - slider.clientWidth - 2;
  }

  /*
   * Arrastar com o dedo dentro do drawer.
   *
   * Quando o carrinho abre, o tema tranca a rolagem da página com um
   * listener de touchmove no document que cancela o gesto. Como esta
   * faixa fica fora da área que o tema liberou, o arrasto morria ali.
   * Parar a propagação nos gestos horizontais devolve a rolagem nativa
   * sem mexer na trava do resto da página.
   */
  function habilitarArrasto(slider) {
    if (slider.dataset.rildyArrasto) return;
    slider.dataset.rildyArrasto = 'true';

    var x0 = 0;
    var y0 = 0;

    slider.addEventListener(
      'touchstart',
      function (event) {
        x0 = event.touches[0].clientX;
        y0 = event.touches[0].clientY;
      },
      { passive: true }
    );

    slider.addEventListener(
      'touchmove',
      function (event) {
        var toque = event.touches[0];
        if (Math.abs(toque.clientX - x0) > Math.abs(toque.clientY - y0)) {
          event.stopPropagation();
        }
      },
      { passive: true }
    );
  }

  function varrer() {
    document.querySelectorAll('.rildy-pair [data-pair-products]').forEach(function (slider) {
      desmontarCarrossel(slider);
      atualizarSetas(slider);
      habilitarArrasto(slider);

      if (!slider.dataset.rildyScrollBound) {
        slider.dataset.rildyScrollBound = 'true';
        slider.addEventListener('scroll', function () {
          atualizarSetas(slider);
        });
      }
    });
  }

  var agendado = false;
  function agendarVarredura() {
    if (agendado) return;
    agendado = true;
    requestAnimationFrame(function () {
      agendado = false;
      varrer();
    });
  }

  new MutationObserver(agendarVarredura).observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  window.addEventListener('resize', agendarVarredura);
  agendarVarredura();

  /*
   * "Continuar comprando": o tema recolhe os botões que fecham o drawer
   * no carregamento da página, e este link nasce depois, quando o
   * template do drawer é clonado. Reaproveitamos o X do próprio drawer,
   * que já está ligado ao fechamento do tema.
   */
  document.addEventListener('click', function (event) {
    var link = event.target.closest('[data-rildy-continuar]');
    if (!link) return;

    event.preventDefault();

    var fechar = document.querySelector('.cart-drawer .cart-drawer__close');
    if (fechar) fechar.click();
  });

  document.addEventListener('click', function (event) {
    var prev = event.target.closest('[data-rildy-pair-prev]');
    var next = event.target.closest('[data-rildy-pair-next]');
    if (!prev && !next) return;

    event.preventDefault();

    var pair = (prev || next).closest('.rildy-pair');
    var slider = pair && pair.querySelector('[data-pair-products]');
    if (!slider) return;

    var card = slider.querySelector('.product-upsell__holder');
    var passo = card ? card.getBoundingClientRect().width + 10 : slider.clientWidth / 2;

    slider.scrollBy({ left: prev ? -passo : passo, behavior: 'smooth' });
  });
})();
